import ResetPasswordVerify from '@/views/ResetPasswordVerify';
import withAuth from '@/components/withAuth';

export default withAuth(ResetPasswordVerify);
